import { render, staticRenderFns } from "./404.vue?vue&type=template&id=29a70a84"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a70a84')) {
      api.createRecord('29a70a84', component.options)
    } else {
      api.reload('29a70a84', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=29a70a84", function () {
      api.rerender('29a70a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/error-page/404.vue"
export default component.exports